/**
 * PayPal Donate SDK has no documented close(); dismiss overlay after payment.
 */
export function dismissPaypalDonatePopup() {
    if (typeof document === 'undefined') return;

    document.querySelectorAll('.paypal-checkout-close').forEach((el) => {
        if (el instanceof HTMLElement) el.click();
    });

    document.querySelectorAll('[class*="paypal-checkout"]').forEach((el) => {
        if (!(el instanceof HTMLElement) || el.closest('.paypal-donate-mount')) return;
        const cls = typeof el.className === 'string' ? el.className : '';
        if (
            cls.includes('paypal-checkout-sandbox') ||
            cls.includes('paypal-checkout-overlay') ||
            cls.includes('paypal-checkout-iframe-container')
        ) {
            el.remove();
        }
    });

    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
}

/** Overlay may render slightly after onComplete; retry dismiss briefly. */
export function dismissPaypalDonatePopupSoon() {
    dismissPaypalDonatePopup();
    window.setTimeout(dismissPaypalDonatePopup, 80);
    window.setTimeout(dismissPaypalDonatePopup, 300);
}
